import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../Context/GlobalContext";
import storage from "../Assets/js/Global";
import { imagePath } from "../Url";
import { images } from "../Assets/images";

const DeleteAccount = () => {
  const {
    email,
    sendEmailOTP,
    translatedLabels,
    verifyOTP,
    updateUserData,
    userData,
    isVerified,
    setIsVerified,
    timer,
    resendDisabled,
    resendEmailOTP,
    deleteUserAcc,
    is4Life,
    fourLifeVerifyOTP,
    fourLifeEmailOTP,
    fourLiferesendOTP,
    verifiedsecEmail,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const user = storage.get("loginObj");
  const capitalize = (str) =>
    str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
  const fullName = `${capitalize(user?.firstName)} ${capitalize(
    user?.lastName,
  )}`;
  const resetVerification = () => setIsVerified(false);
  const [showOTPSection, setShowOTPSection] = useState(false);
  useEffect(() => {
    setShowOTPSection(false);
    resetVerification();
  }, []);

  const handleSendOTP = async () => {
    if (is4Life) {
      await fourLifeEmailOTP({
        email:
          user?.userSecondaryEmail.toLowerCase() ||
          verifiedsecEmail?.toLowerCase(),
        module: "deleteUser",
      });
    } else {
      await sendEmailOTP();
    }
    setShowOTPSection(true);
  };

  const handleResendOTP = () => {
    if (resendDisabled) return;

    if (is4Life) {
      fourLiferesendOTP({
        email:
          user?.userSecondaryEmail.toLowerCase() ||
          verifiedsecEmail?.toLowerCase(),
        module: "deleteUser",
      });
    } else {
      resendEmailOTP();
    }
  };

  const handleVerifyOTP = () => {
    if (is4Life) {
      fourLifeVerifyOTP({
        secondaryemail:
          user?.userSecondaryEmail.toLowerCase() ||
          verifiedsecEmail?.toLowerCase(),
        module: "deleteUser",
      });
    } else {
      verifyOTP();
    }
  };

  return (
    <div className="content-part">
      {isVerified ? (
        <div className="">
          <div className="d-flex gap-3">
            <div className="user-profile-image2 position-relative">
              <img
                src={imagePath + user?.profilePhoto || images.userImage}
                alt="user-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.userImage;
                }}
              />
            </div>
            <div className="name-email-part mt-2">
              <h5 className="mb-1">{fullName}</h5>
              <p className="mb-0">
                {/* {email || user?.userEmail} */}
                {is4Life ? user?.userSecondaryEmail : user?.userEmail || email}
              </p>
            </div>
          </div>
          <hr />
          <div>
            <div className="custom-checkbox form-check p-0 custom-checkbox-disabled">
              <input
                type="radio"
                id="userDetails"
                value="userDetails"
                name="userDetails"
                defaultChecked
                disabled
              />
              <label
                className="custom-label fw-semibold ml-4"
                htmlFor="userDetails"
              >
                {authLabel?.user_details?.label_value || "User Details"}
              </label>
            </div>
            <div className="custom-checkbox form-check p-0 mt-2 custom-checkbox-disabled">
              <input
                type="radio"
                id="password"
                value="password"
                name="password"
                defaultChecked
                disabled
              />
              <label
                className="custom-label fw-semibold ml-4"
                htmlFor="password"
              >
                {authLabel?.password?.label_value || "Password"}
              </label>
            </div>
            <div className="custom-checkbox form-check p-0 mt-2 custom-checkbox-disabled">
              <input
                type="radio"
                id="bioMarker"
                value="bioMarker"
                name="bioMarker"
                defaultChecked
                disabled
              />
              <label
                className="custom-label fw-semibold ml-4"
                htmlFor="bioMarker"
              >
                {authLabel?.bio_markers?.label_value || "Bio Markers"}
              </label>
            </div>
          </div>

          <div className="first-msg">
            <p className="mb-0">
              {authLabel?.delete_account_message?.label_value ||
                "We regret to see you go. By deleting your account, you will permanently remove all your data including your profile information and settings. Please note that the deletion process will take 4–5 days to complete. During this time, your transaction history and invoices will be retained as part of our records in accordance with our policies."}
            </p>
          </div>

          <div className="second-msg">
            {authLabel?.delete_msg3?.label_value ||
              "If you have any questions or require assistance, please contact our support team at "}{" "}
            <a href="mailto:support@healthy4life.ai" className="fw-semibold">
              support@healthy4life.ai{" "}
            </a>
            {authLabel?.delete_msg4?.label_value || "or visit our Help Center"}.
          </div>

          <div className="my-4 text-center">
            <button onClick={deleteUserAcc} className="btn btn-primary">
              {authLabel?.confirm?.label_value || "Confirm"}
            </button>
          </div>
        </div>
      ) : !showOTPSection ? (
        <div className="">
          <div className="alert alert-warning py-1 px-2 mt-3 fs-15px">
            {authLabel?.dlt_action_text?.label_value ||
              "This action will permanently delete your account"}
          </div>

          <div className="form-group mb-2">
            <label className="form-label">
              {authLabel?.email?.label_value || "Email"}
            </label>
            <input
              type="email"
              className="form-control wrInputText"
              placeholder={
                authLabel?.enter_your_email?.label_value || "Enter e-mail"
              }
              value={
                is4Life ? user?.userSecondaryEmail : user?.userEmail || email
              }
              disabled
            />
          </div>
          <div className="my-4 text-center">
            <button onClick={handleSendOTP} className="btn btn-primary">
              {authLabel?.verify?.label_value || "Verify"}
            </button>
          </div>

          <div className="alert alert-info p-2">
            <div className="d-flex align-items-start">
              <i className="fas fa-info-circle text-primary mt-1 me-2"></i>
              <div>
                <p className="fw-semibold mb-1">
                  {authLabel?.what_happens_next?.label_value ||
                    "What happens next?"}
                </p>
                <ul className="list-unstyled mb-0">
                  <li>
                    •{" "}
                    {authLabel?.dlt_step_1?.label_value ||
                      "We'll send a verification code to your email"}
                  </li>
                  <li>
                    •{" "}
                    {authLabel?.dlt_step_2?.label_value ||
                      "Enter the code to confirm your identity"}
                  </li>
                  <li>
                    •{" "}
                    {authLabel?.dlt_step_3?.label_value ||
                      "Review what data will be deleted"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <section>
          <div className="">
            <h3 className="text-center mb-4">
              {authLabel?.verification_code?.label_value || "Verification Code"}
            </h3>
            <div className="form-group text-center">
              <p className="form-label">
                <span>
                  {authLabel?.your_email?.label_value || "Your Email"}
                </span>
                :{" "}
                <span className="fw-semibold">
                  {/* {email || user?.userEmail} */}
                  {is4Life
                    ? user?.userSecondaryEmail
                    : user?.userEmail || email}
                </span>
              </p>
            </div>
            <p className="text-center fs-14px text-muted">
              {authLabel?.enter_email_code?.label_value ||
                "Please enter the 6-digit code sent to your email"}
            </p>
            <div className="otp-container">
              <input
                type="text"
                maxLength="6"
                className="otp-input"
                placeholder="------"
                value={userData.otp}
                onChange={(e) => updateUserData("otp", e.target.value)}
              />
            </div>
            <p className="fw-semibold text-center">
              {authLabel?.didnt_receive_code?.label_value ||
                "Didn’t receive the verification code?"}
              <span
                onClick={handleResendOTP}
                className="ms-1 text-decoration-none fw-semibold text-primary"
                style={{
                  cursor: resendDisabled ? "not-allowed" : "pointer",
                  opacity: resendDisabled ? 0.6 : 1,
                  pointerEvents: resendDisabled ? "none" : "auto",
                }}
              >
                {authLabel?.resend?.label_value || "Resend"}
              </span>
            </p>
            {resendDisabled && (
              <p className="text-center fst-italic timer-part">
                {authLabel?.resend_otp_in?.label_value || "Resend OTP in"}{" "}
                <span
                  id="countdownTimer"
                  className="fw-semibold text-primary"
                >
                  00:{timer < 10 ? `0${timer}` : timer} Sec
                </span>
              </p>
            )}
            <div className="mt-4 text-center">
              <button onClick={handleVerifyOTP} className="btn btn-primary">
                {authLabel?.confirm?.label_value || "Confirm"}
              </button>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default DeleteAccount;
